import React from 'react';
import Carousel from './Carousel';

import VideoSlider from './VideoSlider';
import Vehicles from '../pages/Vehicles';
import WhyChooseUs from '../pages/WhyChooseUs';
import SpecialDeals from '../pages/SpecialDeals';
import PopularRentalLocations from '../pages/PopularRentalLocations';
import Testimonials from '../pages/Testimonials';
import FAQ from '../pages/FAQ';
import CTASection from '../pages/CTASection';





const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
{/* <Carousel/> */}
<VideoSlider/>
<Vehicles/>
<WhyChooseUs/>
{/* <SpecialDeals/> */}
<PopularRentalLocations/>
<Testimonials/>
<FAQ/>
<CTASection/>


    </div>
  );
};

export default HeroSection;
